import { Attribute } from "@angular/core";
import { AbstractControl, FormGroup, FormControl } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';

// Validator to compare two strings and set mismatchedElements flags to true if they are not equal.
export function compareElements(inputPassword: string, inputConfirmPassword: string) {
    return (group: FormGroup): { [key: string]: any } => {
        const password = group.controls[inputPassword];
        const confirmPassword = group.controls[inputConfirmPassword];

        if (password.value !== confirmPassword.value) {
            return {
                mismatchedElements: true
            };
        }
    };
}

export function isValidMailFormat(control: FormControl) {
    const EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i;

    if (control.value && control.value !== '' && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
        return {
            invalidEmail: true
        };
    }
    return null;
}

export function unsavedFormCheck(
    event: KeyboardEvent, dialogRef: MdDialogRef<any>, formGroup: FormGroup) {
    if (event.keyCode === 27 && formGroup.dirty) {
        if (confirm(MessageService.UNSAVED_FORM_ALERT)) {
            dialogRef.close();
        } else {
            event.stopPropagation();
            return false;
        }
    }
}

// checks and sets the form errors
export function FormErrors(formName, scope) {
    const form = scope[formName];
    for (const field in scope['formErrors']) {
        if (scope['formErrors'].hasOwnProperty(field)) {
            scope['formErrors'][field] = '';
            const control = form.get(field);
            if (control && (control.dirty || control.touched) && !control.valid) {
                const messages = scope['validationMessages'][field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        var msg = (!messages[key] ? 'err: ' + key : messages[key]);
                        scope['formErrors'][field] += msg + ' ';
                    }
                }
            }
        }
    }
}

export function ValidateAmount(control: AbstractControl) : any {
    var amount = control.value;
    if (!!amount){
        if (amount.toString().indexOf(",") !== -1) {
            return { decimal: true };
        } else if (isNaN(amount) || (Number(amount) <= 0)) {
            return { numeric: true };
        }
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/app/shared/validators/generic-validators.ts